import { useTranslation } from 'react-i18next';
import { useEffect, useRef, useState } from 'react';

import './AddUser.scss';

interface AddUserProps {
  onClick: (user: string) => void;
}

export const AddUser = ({ onClick }: AddUserProps) => {
  const { t } = useTranslation('document-permissions');

  const [userName, setUserName] = useState('');
  const inputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    inputRef.current?.focus();

    return () => {
      setUserName('');
    };
  }, []);

  const handleAddUser = (event: React.FormEvent) => {
    event.preventDefault();

    //TODO: validate user here?

    onClick(userName);
    setUserName('');
  };

  return (
    <div className="add-user">
      <form onSubmit={handleAddUser}>
        <input
          type="text"
          name="username"
          value={userName}
          ref={inputRef}
          placeholder={t('field.placeholder.new-user')}
          onChange={(event) => setUserName(event.target.value)}
        />

        <button type="submit" className="button btn btn-secondary" disabled={!userName}>
          {t('button.new-user')} {userName}
        </button>
      </form>
    </div>
  );
};
